<template>
  <TransitionGroup name="notify-slide" tag="div" class="notify-bar">
    <div
      v-for="item in notify.state.items"
      :key="item.id"
      :class="['notify-item', `notify-${item.type}`]"
    >
      <span class="notify-icon">{{ iconMap[item.type] }}</span>
      <span class="notify-msg">{{ item.message }}</span>
      <button v-if="item.duration === null" class="notify-close" @click="notify.remove(item.id)">
        ✕
      </button>
    </div>
  </TransitionGroup>
</template>

<script setup lang="ts">
import { notify } from '@/utils/notify'

const iconMap: Record<string, string> = {
  success: '✓',
  error: '✗',
  warning: '⚠',
  info: 'ℹ',
}
</script>

<style scoped>
.notify-bar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 12px;
  pointer-events: none;
}

.notify-item {
  pointer-events: auto;
}

.notify-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-radius: 6px;
  font-size: 14px;
  line-height: 1.5;
  position: relative;
}

.notify-success {
  background-color: #e8ffea;
  color: #00b42a;
  border: 1px solid #c0f0c6;
}

.notify-error {
  background-color: #ffece8;
  color: #f53f3f;
  border: 1px solid #fdcdc5;
}

.notify-warning {
  background-color: #fff7e8;
  color: #ff7d00;
  border: 1px solid #ffe4ba;
}

.notify-info {
  background-color: #e8f3ff;
  color: #1677ff;
  border: 1px solid #bedaff;
}

.notify-icon {
  flex-shrink: 0;
  font-size: 16px;
  font-weight: 700;
}

.notify-msg {
  flex: 1;
  word-break: break-all;
}

.notify-close {
  flex-shrink: 0;
  background: none;
  border: none;
  font-size: 14px;
  cursor: pointer;
  color: inherit;
  opacity: 0.6;
  padding: 0 2px;
}

.notify-close:hover {
  opacity: 1;
}

.notify-slide-enter-active,
.notify-slide-leave-active {
  transition: all 0.3s ease;
}

.notify-slide-enter-from,
.notify-slide-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}
</style>
